const NebulaBackground = () => {
  return (
    <div 
      aria-hidden="true"
      role="presentation"
      className="absolute inset-0 pointer-events-none"
      style={{
        background: 'hsl(240 5% 12% / 1)',
        zIndex: 0,
        willChange: 'transform, opacity',
        transform: 'translateZ(0)'
      }}
    >
      {/* Purple nebula cloud - top left */}
      <div 
        className="absolute w-[800px] h-[800px] -top-48 -left-48 opacity-40"
        style={{
          background: 'radial-gradient(circle, hsl(252 69% 45% / 0.3) 0%, hsl(252 69% 30% / 0.2) 30%, transparent 70%)',
          filter: 'blur(60px)',
          willChange: 'opacity, transform',
          transform: 'translateZ(0)'
        }}
      />
      
      {/* Blue nebula cloud - top right */}
      <div 
        className="absolute w-[700px] h-[700px] -top-32 -right-32 opacity-35"
        style={{
          background: 'radial-gradient(circle, hsl(199 95% 48% / 0.25) 0%, hsl(199 95% 35% / 0.15) 40%, transparent 70%)',
          filter: 'blur(70px)',
          willChange: 'opacity, transform',
          transform: 'translateZ(0)'
        }}
      />
      
      {/* Golden energy burst - center right (main feature) */}
      <div 
        className="absolute w-[1000px] h-[1000px] top-1/4 right-0 opacity-30"
        style={{
          background: 'radial-gradient(ellipse at center, hsl(39 100% 60% / 0.4) 0%, hsl(33 100% 50% / 0.3) 20%, hsl(252 69% 45% / 0.2) 50%, transparent 70%)',
          filter: 'blur(80px)',
          mixBlendMode: 'screen',
          willChange: 'opacity, transform',
          transform: 'translateZ(0)'
        }}
      />
      
      {/* Pink nebula accent - bottom left */}
      <div 
        className="absolute w-[600px] h-[600px] -bottom-24 -left-24 opacity-25"
        style={{
          background: 'radial-gradient(circle, hsl(330 70% 55% / 0.25) 0%, hsl(330 70% 40% / 0.15) 40%, transparent 70%)',
          filter: 'blur(65px)',
          willChange: 'opacity, transform',
          transform: 'translateZ(0)'
        }}
      />
      
      {/* Deep purple cloud - center */}
      <div 
        className="absolute w-[900px] h-[900px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-20"
        style={{
          background: 'radial-gradient(circle, hsl(270 60% 35% / 0.3) 0%, hsl(270 60% 25% / 0.2) 40%, transparent 70%)',
          filter: 'blur(90px)',
          willChange: 'opacity, transform',
          transform: 'translateZ(0)'
        }}
      />
      
      {/* Teal accent - bottom right */}
      <div 
        className="absolute w-[500px] h-[500px] -bottom-32 right-1/4 opacity-20"
        style={{
          background: 'radial-gradient(circle, hsl(180 70% 45% / 0.2) 0%, hsl(180 70% 35% / 0.1) 40%, transparent 70%)',
          filter: 'blur(55px)',
          willChange: 'opacity, transform',
          transform: 'translateZ(0)'
        }}
      />
    </div>
  );
};

export default NebulaBackground;